module.exports = __webpack_public_path__ + "static/img/product01.a911315.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product01.png
// module id = 8uor
// module chunks = 1